export class AplatzLocationRequest
{
    PersonnelCode: string;
}

export class ProductionRequest{
    APLATZ_ID:string
}